import { LeagueSettings } from '../league-setting';
import { UUID } from '../uuid';
export class LeagueSettingForm {
  public league_id: UUID;
  public border_color: string;
  public header_text_color: string;
  public header_background_color: string;
  public row_text_color: string;
  public alt_row_text_color: string;
  public row_background_color: string;
  public alt_row_background_color: string;
  public background_color: string;
  public banner_text_color: string;
  public banner_background_color_inside: string;
  public banner_background_color_outside: string;
  public button_background_color: string;
  public button_text_color: string;
  public footer_background_color: string;
  public footer_text_color: string;

  constructor(model: LeagueSettings) {
    this.league_id = model.league_id;
    this.border_color = model.border_color;
    this.header_text_color = model.header_text_color;
    this.header_background_color = model.header_background_color;
    this.row_text_color = model.row_text_color;
    this.alt_row_text_color = model.alt_row_text_color;
    this.row_background_color = model.row_background_color;
    this.alt_row_background_color = model.alt_row_background_color;
    this.background_color = model.background_color;
    this.banner_text_color = model.banner_text_color;
    this.banner_background_color_inside = model.banner_background_color_inside;
    this.banner_background_color_outside = model.banner_background_color_outside;
    this.button_background_color = model.button_background_color;
    this.button_text_color = model.button_text_color;
    this.footer_background_color = model.footer_background_color;
    this.footer_text_color = model.footer_text_color;
  }
}
